<template>
  <v-container class="topo px-0" fluid>
  <!-- -------------- PARTE DE CIMA ----------------- -->
    <!-- <v-container
      class="first-row"
      fluid
    > -->
    <v-row
      v-if="videos"
      class="py-12 px-10 justify-center"
    >
      <!-- {{ videos }} -->
      <v-col
        v-for="(video, i) in videos"
        :key="i"
        cols="12"
        md="4"
      >
        <v-card
          :disabled="!video.open || !(video.id in $store.getters.getUser.cursos)"
          outlined
          class="px-0"
        >
          <v-sheet v-if="video.img" class="video round-corner" width="100%">
            <v-responsive :aspect-ratio="16/9">
              <v-img
                :alt="video.desc"
                class="logo-top shrink"
                :src="require(`@/assets/${video.img}.png`)"
                transition="scale-transition"
              ></v-img>
            </v-responsive>
          </v-sheet>
          <v-card-title>
            
          </v-card-title>
          <!-- {{ video.display }} -->
          <!-- {{ video.url }} -->
          <v-card-text>
            <span class="allcaps caption cc-primary--text mb-2">Curso</span>
            <!-- <h2 class="mb-2">{{ video.title }}</h2> -->
            <!-- <p class="mb-4">15 de Julho de 24</p> -->
            <!-- <p>{{ hasAccess(video.id) }}</p> -->
            <!-- <p>{{ !(video.id in $store.getters.getUser.cursos) }}</p> -->
            <p class="">{{ video.desc }}</p>
            <div
              v-if="video.open"
            >
              <v-btn
                v-if="hasAccess(video.id)"
                depressed
                large
                block
                class="btn-primary mt-4"
                @click.stop="$router.push({name: video.id})"
              >
                Ir para curso
                <v-icon right>mdi-arrow-right</v-icon>
              </v-btn>
              <v-btn
                v-else
                depressed
                large
                block
                class="btn-primary mt-4"
                href="https://wa.me/+5521920088559"
                target="_blank"
              >
                Garantir acesso
                <v-icon right>mdi-arrow-right</v-icon>
              </v-btn>

            </div>
            <v-btn
              v-else
              depressed
              disabled
              large
              block
              class="grey mt-4"
            >
              Em breve
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <HelpDialog />
    <!-- </v-container> -->
    <Footer />

    <CompForm />

    <!-- LGPD -->
    <LGPD />
  </v-container>
</template>

<script>
// import HelloWorld from '../components/HelloWorld'
import db from '@/firebase/init'
import firebase from 'firebase'
import moment from 'moment'
import CompForm from '@/components/auth/CompForm'
import LGPD from '@/components/LGPD/LGPD'
import MainSlider from '@/components/sliders/mainSlider.vue'
import GoLive from '@/components/layout/GoLive'
import {mapGetters, mapActions} from "vuex"
import Footer from '@/components/layout/NewFooter'
import HelpDialog from '@/components/layout/HelpDialog'
// import ShareBtn from '@/components/ShareBtn.vue'

export default {
  name: 'Index',
  components: {
    MainSlider,
    LGPD,
    // ShareBtn,
    CompForm,
    GoLive,
    Footer,
    HelpDialog
  },
  data(){
    return{
      golive: false,
      user: null,
      comentario: null,
      comentarios: [],
      video: {},
      show: false,
      sponsors: [],
      patrocinio: [],
      videos: [],
      hoje: Date.now(),
      testcomments: [
        {
          from: "angelaguerrarj@gmail.com",
          msg: "Muito boa a aula. Parabéns Cinthia, obrigada Selma pelas apresentações.",
          timestamp: 1602634938843,
        }
      ],
      programa: [
        {
          title: 'Bloco 1 - O Canabidiol e Seus Derivados',
          palestras: [
            {
              hora: '08h - 8:10h',
              nome: 'Abertura e apresentação dos palestrantes',
              palestrante: 'Dra. Selma Merenlender'
            },
            {
              hora: '08:10h - 8:30h',
              nome: 'História da Cannabis medicinal',
              palestrante: 'Dra. Selma Merenlender'
            },
            {
              hora: '8:30h - 09h',
              nome: 'Legislação e normas da Cannabis medicinal no Brasil',
              palestrante: 'Dra. Alessandra Soares'
            },
            {
              hora: '09h - 09:30h',
              nome: 'Sistema endocanabinoide',
              palestrante: 'Dra. Selma Merenlender'
            },
            {
              hora: '09:30h - 09:50h',
              nome: 'Fitocanabinoides: CBD, THC, Terpenos e Flavonoides',
              palestrante: 'Dra. Selma Merenlender'
            },
            {
              hora: '09:50h - 10h',
              nome: 'Perguntas e respostas',
              palestrante: ''
            },
            {
              hora: 'Intervalo de 15 minutos',
              nome: '',
              palestrante: ''
            },
          ]
        },
        {
          title: 'Bloco 2 - Indicações do Canabidiol',
          palestras: [
            {
              hora: '10:15h – 10:45h',
              nome: 'Aplicações Clínicas: Geriatria e Medicina paliativa',
              palestrante: 'Dr. Filipe Gusman'
            },
            {
              hora: '10:45h – 11:00h',
              nome: 'Aplicações Clínicas: Medicina do Esporte – Doping no Esporte',
              palestrante: 'Dr José Kawazoe'
            },
            {
              hora: '11:00h – 11:30h',
              nome: 'Aplicações Clínicas: Medicina do Esporte',
              palestrante: 'Dra Natalia Mourão/ Dr. Jimmy Fardin'
            },
            {
              hora: '11:30h – 12:00h',
              nome: 'Aplicações Clínicas: Lesões de atletas',
              palestrante: 'Diogo Souza'
            },
            {
              hora: 'Intervalo de 20 minutos',
              nome: '',
              palestrante: ''
            },
          ]
        },
        {
          title: 'Bloco 3 - Prescrições e casos clínicos do Canabidiol e seus derivados',
          palestras: [
            {
              hora: '12:20h – 12:50h',
              nome: 'Aplicações Clínicas : Psiquiatria',
              palestrante: 'Dr. Octavio Pavan'
            },
            {
              hora: '12:50h – 13:20h',
              nome: 'Aplicações Clínicas : Reumatologia',
              palestrante: 'Dra. Selma Merenlender'
            },
            {
              hora: '13:20h – 14:00h',
              nome: 'Casos Clínicos, regras para prescrição e Fechamento',
              palestrante: 'Dra. Selma Merenlender'
            },
          ]
        },

      ],
    }
  },
  computed: {
    ...mapGetters(['getGoLiveEnabled']),
  },
  beforeMount() {
    // this.getVideo()
    this.getVideos()
    this.getVideoAction()
  },
  mounted() {
    this.$vuetify.theme.dark = false
    moment.locale('pt-br')
    // console.log(moment(Date.now()).format('dddd'))
    firebase.auth().onAuthStateChanged(user => {
      this.user = user
    })

    // Cria um timestamp 1 ano no futuro para usar como data de validade do curso. utilizado na função abaixo
    // const dt = new Date()
    // console.log(dt)
    // console.log(dt.getTime())
    // var year = dt.getFullYear()
    // var month = dt.getMonth()
    // var day = dt.getDate()
    // var expiresOn = new Date(year + 1, month, day)
    // console.log(expiresOn)
    // console.log(expiresOn.getTime())


    // Cria uma data a partir de uma dtString
    // console.log(new Date(2024, 10, 11))
    // const dtString = '2024-10-11'
    // const dtSplit = dtString.split('-')
    // console.log(new Date(dtSplit[0], dtSplit[1], dtSplit[2]))

    // console.log(this.$store.getters.getUser)
    // console.log(this.user)
    // this.getVideo()

    // NÃO DESCOMENTAR!!!!!!!!!!!
    // - Atualiza a prop 'cursos' na tabela 'usuarios' baseado no 'cc3'- 
    //
    // db.collection('usuarios')
    //   .where('cc3', '==', true)
    //   .get()
    //   .then((docs) => {
    //     let i = 0
    //     docs.forEach(doc => {
    //       i++
    //       // console.log(doc.id)
    //       // console.log(doc.data())

    //       db.collection('usuarios')
    //         .doc(doc.id)
    //         .update({
    //           'cursos.cc3': expiresOn.getTime()
    //         }).then(() => {
    //           console.log('atualizou')
    //         }).catch((e) => {
    //           console.log(e.message)
    //         })
    //     });
    //     console.log(i, ' usuários atualizados')
    //   })
  },
  updated() {
    this.comentarios.forEach(comentario => {
      let ts = comentario.timestamp
      if (!isNaN(ts)){
        let dif = ts - this.hoje
        if(dif < 0){
          comentario.timestamp = this.getTime(ts)
        } else {
          comentario.timestamp = moment(comentario.timestamp).format('HH:mm')
        }

      }

      // console.log(ts)
    })
  },
  methods: {
    ...mapActions(['getVideoAction']),

    trocaVideo(novo, i){
      // console.log(novo.videoId, i)
      let velho = this.video
      this.patrocinio = []
      this.video = novo
      if(novo.patrocinio){
        let novoPat = 'https://centrofluminense.com.br/webmeeting-img/img/' + novo.patrocinio

        this.patrocinio.push(novoPat)
      }

      this.comentarios = []
      this.getComments(novo.videoId)
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    getTime(time){
      // let fTime = moment(time).calendar()
      let fTime = moment(time).fromNow()
      // console.log(fTime)
      return fTime
    },
    sendMessage(){
      // let timestamp = Date.now()
      if(this.comentario){

        // console.log(this.video.videoId)
        let vid = db.collection('videos').doc(this.video.videoId)
        vid.collection('comments')
        .add({
          timestamp: Date.now(),
          msg: this.comentario,
          from: this.user.email,
        }).then(() => {
          this.comentario = null
        })
      } else{
        return false
      }
      // db.collection('comments_2020-05-26')
    },
    getVideo(){
      db.collection('videos').get().then(snapshot => {
        snapshot.docs.forEach(doc => {
          let video = doc.data()
          video.videoId = doc.id

          if(video.display){
          // if(doc.id === 'EdGQQop0SkgSOJ9qs7cz'){
            this.getComments(doc.id)
            this.video = video
            // console.log(video.data.toDate())
            if(video.patrocinio){
              video.patrocinio.forEach(patrocinador => {
                let pat = 'https://centrofluminense.com.br/webmeeting-img/img/' + patrocinador
                this.patrocinio.push(pat)
              })
            }else if(video.sponsors){
              video.sponsors.forEach(sponsor => {
                let spn = 'https://centrofluminense.com.br/webmeeting-img/img/' + sponsor
                this.sponsors.push(spn)
              })
            }

          } else{
            // console.log('video sem display')
            if (video.url){
              this.videos.push(video)
            }
          }

        });
      });
      // console.log(this.videos)
    },
    getVideos(){
      db.collection('videos').get().then(snapshot => {
        snapshot.docs.forEach(doc => {
          let video = doc.data()

          if(video.display){
            this.videos.push(video)
          }

        })
      });
      // console.log(this.videos)
    },
    getComments(id){

      // console.log(id)
      let vid = db.collection('videos').doc(id)

      vid.collection('comments').orderBy("timestamp", "asc")
      .onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if(change.type === "added"){
            let comm = change.doc.data()
            comm.id = change.doc.id
            this.comentarios.unshift(comm)
            // this.updateScroll()
          }
          if(change.type === "removed"){
            // console.log('change.doc.id: ' + change.doc.id)
            // console.log('array comentarios: ' + this.comentarios)
            let comm = change.doc.data()
            comm.id = change.doc.id
            for (let i = 0; i < this.comentarios.length; i++) {
              // console.log('entrou aqui no for')
              // console.log('comm: ', comm.id)
              // console.log('this.comentarios[i].id: ', this.comentarios[i].id)
              if (this.comentarios[i].id === comm.id) {
                // console.log('achei')
                this.comentarios.splice(i, 1)
              } else {
                // console.log('nao achei')
              }
            }
          }
        })
      })
    },
    updateScroll(){
      let commentList = document.querySelector('#comment-list');
      commentList.scrollTop = commentList.scrollHeight + 100;
    },
    goToClass(route) {
      // if(this.$store.getters.getUser.cc22){
      if(this.$store.getters.getUser.cc3){
        this.$router.push({ name: route })
      } else {
        firebase.auth()
          .signOut()
          .then(() => {
            this.$store.commit("setUser", null);
            this.$store.commit("setEmailChecked", false)
            this.$router.push('/pre-inscricao')
            window.sessionStorage.clear();
          })
          .catch(error => {
            this.$store.commit("setError", error.message);
          });
      }
    },
    hasAccess(cursoID) {
      const userCursos = this.$store.getters.getUser.cursos
    
      // console.log(cursoID in userCursos)
      // console.log(userCursos[cursoID] > Date.now())

      if(cursoID in userCursos) {
        return userCursos[cursoID] > Date.now()
      } else {
        return false
      }
    }
  },
}
</script>

<style lang="scss">
@import '@/variables/style.scss';

.topo{
  // background-color: $primary;
  padding-top: 0px;

  .bg{
    // background-color: $primary;
    min-height: 600px;
  }
  .first-row{
    margin-top: -600px;
  }
  .video{

    iframe{
      width: 100%;
      height: 100%;
    }
  }
  .video-title{
    font-size: 2rem
  }
  .sponsors{

    .v-image{
      // max-width: 40px;
    }
  }
  .show-more-btn{
    text-transform: none !important;
    letter-spacing: 1px;
  }
  .ad{
    // position: absolute;
    // bottom: 0;
  }
  .gradient-overlay{
    height: 100px;
    position: sticky;
    bottom: -8px;
    left: 0;
    right: 0;
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    background: linear-gradient(0deg, rgba(250,250,250,1) 0%, rgba(255,255,255,.0) 100%);
    &.theme--dark{
      background: linear-gradient(0deg, rgba(30,30,30,1) 0%, rgba(30,30,30,.0) 100%);
    }
  }
  .comment-col {
    overflow: hidden;
    position: relative;
    @include xs {
      min-height: 40vh;
    }
  }
  .comment-container{
    // min-height: 85%;
    overflow-y: scroll;
    -ms-overflow-style: none;
    min-height: 450px;
    max-height: 550px;

    &::-webkit-scrollbar {
      display: none;
    }
  }
  .get-online{
    min-height: 13%;
  }
  #comment-list{

    div{
      background-color: #E0F2F1;
    }
    p{
      font-size: .8em;
      margin-bottom: 0px;

      span{
        font-weight: 300;
        font-size: .7em;
        float: right
      }
    }
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .com{
    font-size: .8em;
    background-color: transparent;
    height: 60%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .comment-input{
    // background-image: -webkit-linear-gradient(rgba(255,255,255,0.001) 0%, white 20%);

    .com-input{

      .v-icon{
        background-color: #BDBDBD;
      }

      &.v-input--is-focused{

        .v-label--active{
          color: black;
        }
        .v-icon{
          color: white !important;
          background-color: #00BFA5;
        }
      }
    }
  }
}
.videos{

  .v-card__title{
    font-size: 1em
  }
}

</style>
